import { jsPDF } from "jspdf";
import { defineStore, acceptHMRUpdate } from "pinia";

export const usePDF = defineStore("pdf", {
  state: () => ({}),
  getters: {},
  actions: {
    downloadPDF(eg) {
      let doc = new jsPDF();
      // doc.addImage(eg, "JPEG", 15, 15, 185, 150);
      // doc.save("Chart.pdf");
      let screenWidth = eg.clientWidth;
      eg.style.width = "1400px";

      doc.html(eg, {
        callback: function (doc) {
          doc.save("Chart.pdf");
        },
        x: 2,
        y: 10,
        width: 1400,
        html2canvas: { scale: 0.15 },
      });

      setTimeout(() => {
        eg.style.width = "100%";
      }, 1000);
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePDF, import.meta.hot));
}
